import { useCallback, useState, useEffect } from "react";
import EventCard from "../component/EventCard";
import InputCard from "../component/InputCard";
import { useDecodedParams } from "../misc/utils";
import { useForm, Controller } from "react-hook-form";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExampleComp from "../component/ExampleComp";
import { useAws } from "../aws";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";

const EventDetailPage = () => {
  const { x_api_key, x_api_key_cms } = useAws();
  const { t } = useTranslation();
  const { id } = useDecodedParams();
  const { awsHttp, uploadToS3, supdocPrefix } = useAws();
  const [userInfo, setUserInfo] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("FPS");
  const hookForm = useForm({ mode: "all" });
  const { handleSubmit, clearErrors, setValue, getValues, trigger, reset } = hookForm || {};

  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [fetched, setFetched] = useState(false);
  const [price, setPrice] = useState(0);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const inputCardProps = {
    hookForm,
    paymentItmeProps: {
      paymentMethod,
      setPaymentMethod,
    },
    price,
  };

  const onSubmit = (data) => {
    if (data?.files?.length > 0) {
      // Upload every supporting document and enrol only once ALL of them have landed
      // (the old code proceeded when the last-indexed upload finished, regardless of the
      // others). A failed upload is reported instead of silently leaving a dead button.
      Promise.all(data.files.map((item) => uploadToS3(item.file, supdocPrefix + item.data.filename)))
        .then(() => proceedEnrollment(data))
        .catch((e) => {
          console.error("supporting document upload failed", e);
          alert("上載文件失敗，請重試。\n" + (e?.message || ""));
        });
    } else {
      proceedEnrollment(data);
    }
  };

  const proceedEnrollment = (input) => {
    let _data = { ...input, paymentMethod: paymentMethod };
    if (input.skuIndex != null) {
      _data["event_id"] = id;
      _data["skuName"] = data.sku[_data.skuIndex]?.name;
      _data["NN2C"] = data.sku[_data.skuIndex].options[_data.optionIndex].price === 0 ? true : false;
    }

    if (paymentMethod == "Card") {
      let isLoading = true;

      axios
        .post(
          (process.env.REACT_APP_ENV == "DEV"
            ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api"
            : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") + "/user/applyevent",
          processEventEnrollmentData(_data),
          {
            headers: {
              "x-api-key": x_api_key,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res.data.body);
          _data = { ..._data, payment_id: res.data.body };
          console.log(_data);
          isLoading = false;
          handleStorageEvent(_data);
        });
    } else {
      handleStorageEvent(_data);
    }

    // window.sessionStorage.setItem("event", JSON.stringify(_data));
    // navigate("/confirmation/event");
  };

  const processEventEnrollmentData = (data) => {
    const p = {
      event_id: data.event_id,
      detail: {
        name: {
          prefix: data.prefix,
          zh_last_name: data.chineseLastname,
          zh_first_name: data.chineseFirstname,
          en_last_name: data.englishLastname,
          en_first_name: data.englishFirstame,
        },
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        contact_phone_region: data.phoneType || "",
        birth_year: parseInt(data.birthYear),
        birth_month: parseInt(data.birthMonth.split("月")[0]),
        address: data.livingArea,
        job: data.job,
        supporting_doc: data?.files?.length ? data.files.map((file) => file.data.filename) : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
      promo_terms: data["pi-0"] ? "yes" : "no",
      film_terms: data["pi-1"] ? "yes" : "no",
      payment_method: data.paymentMethod,
    };
    return p;
  };

  const handleStorageEvent = (data) => {
    window.sessionStorage.setItem("event", JSON.stringify(data));
    navigate("/confirmation/event");
  };

  const submitData = (data) => {
    const requestBody = {
      event_id: id,
      detail: {
        name: {
          prefix: data.prefix,
          zh_last_name: data.chineseLastname,
          zh_first_name: data.chineseFirstname,
          en_last_name: data.englishLastname,
          en_first_name: data.englishFirstame,
        },
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        contact_phone_region: data.phoneType,
        birth_year: parseInt(data.birthYear),
        birth_month: parseInt(data.birthMonth.split("月")[0]),
        address: data.livingArea,
        job: data.job,
        supporting_doc: data?.files?.length ? data.files.map((file) => file.data.filename) : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
    };
    awsHttp({ HTTPRequestMethod: "POST", APIFunction: "user/applyevent", requestBody: requestBody }).then((res) => {
      console.log(res);
    });
  };

  const printFormData = (event) => {
    if (event.ctrlKey && event.altKey && event.key === "l") {
      console.log(getValues());
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", printFormData);
  }, []);

  useEffect(() => {
    if (!id) return;
    console.log(process.env.REACT_APP_ENV);
    awsHttp({ HTTPRequestMethod: "POST", APIFunction: "user/geteventdetail", requestBody: { event_id: id } }).then((res) => {
      setFetched(true);
      changeStatus(res.data.body);
      setData({ ...res.data.body });
    });
  }, [id]);

  const statusTextList = [
    { value: "active", text: "接受報名", fullValue: "full", full: "活動額滿", expiredValue: "expired", expired: "截止報名" },
    { value: "pause", text: "暫停報名" },
    { value: "stop", text: "截止報名" },
    { value: "cancel", text: "取消活動" },
  ];

  const [status, setStatus] = useState("");
  const [statusText, setStatusText] = useState("");

  const changeStatus = (data) => {
    setStatus(getStatus(data));
    setStatusText(getStatusText(data));
  };

  const getStatus = ({ status, limit, current_user, expires_at }) => {
    switch (status) {
      case statusTextList[0].value:
        if (current_user >= limit) {
          return statusTextList[0].fullValue;
        } else if (new Date().getTime() >= expires_at) {
          return statusTextList[0].expiredValue;
        }
        return statusTextList[0].value;
      case statusTextList[1].value:
        return statusTextList[1].value;
      case statusTextList[2].value:
        return statusTextList[2].value;
      case statusTextList[3].value:
        return statusTextList[3].value;
      default:
        return statusTextList[0].value;
    }
  };
  const getStatusText = ({ status, limit, current_user, expires_at }) => {
    switch (status) {
      case statusTextList[0].value:
        if (current_user >= limit) {
          return statusTextList[0].full;
        } else if (new Date().getTime() >= expires_at) {
          return statusTextList[0].expired;
        }
        return statusTextList[0].text;
      case statusTextList[1].value:
        return statusTextList[1].text;
      case statusTextList[2].value:
        return statusTextList[2].text;
      case statusTextList[3].value:
        return statusTextList[3].text;
      default:
        return statusTextList[0].text;
    }
  };

  const checkShouldShow = (data) => {
    const { current_user, limit, status, expires_at } = data;
    if (status !== "pasue") return false;
    if (current_user >= limit) {
      return false;
    } else if (new Date().getTime() >= expires_at) {
      return false;
    }
    return "active";
  };

  return (
    <div className="page-view event-detail">
      <img className="logo mt-2 mb-6" src="/logoPNB.png" alt="pause-and-breathe-logo" />
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {id ? (
        <>
          {status === "active" ? (
            <form
              key="userInfoForm"
              id="userInfoForm"
              onSubmit={handleSubmit(onSubmit)}
              onKeyPress={(e) => {
                e.key === "Enter" && e.preventDefault();
              }}
            >
              {data && data.name ? (
                <Controller
                  key="option"
                  name="option"
                  control={hookForm.control}
                  defaultValue=""
                  render={({ field, fieldState: { error } }) => (
                    <EventCard data={data} xc="mb-6" error={!!error} setValue={setValue} setPrice={setPrice} trigger={trigger} />
                  )}
                  rules={{
                    required: "Option Null",
                  }}
                />
              ) : (
                ""
              )}

              <InputCard {...inputCardProps} />
              <div className={`my-5 btns-gp-div`}>
                <Button sx={{ marginRight: 2 }} onClick={() => reset()}>
                  {t("Clear")}
                </Button>
                <Button type="submit" variant="contained">
                  {t("Submit")}
                </Button>
              </div>
            </form>
          ) : fetched ? (
            <>
              <p style={{ marginTop: "12px", fontSize: "16px" }}>
                {t(`disabled_${status}`)}
                <a href="mailto:hello@pausebreathe.org" style={{ textDecoration: "none", color: "#1976d2" }}>
                  {" "}
                  hello@pausebreathe.org
                </a>
                {t("learn more")}
              </p>
              <img style={{ maxWidth: "320px", marginTop: "24px" }} src={data.poster} alt="event-detail-poster" />
            </>
          ) : null}
          {fetched ? null : <CircularProgress sx={{ marginTop: "20px" }} />}
        </>
      ) : (
        <>
          <p style={{ marginTop: "12px", fontSize: "16px", textAlign: "center", lineHeight: "32px" }}>
            {t("Event Page diabled")}
            <a href="https://www.pausebreathe.org" style={{ textDecoration: "none", color: "#1976d2" }}>
              {" "}
              www.pausebreathe.org
            </a>
            <br />
            {t("Event Page diabled Email")}
            <a href="mailto:hello@pausebreathe.org" style={{ textDecoration: "none", color: "#1976d2" }}>
              {" "}
              hello@pausebreathe.org
            </a>
          </p>
          {data.poster && data.poster !== "" && data.poster !== undefined ? (
            <img style={{ maxWidth: "320px", marginTop: "24px" }} src={data.poster} alt="event-detail-poster" />
          ) : null}
        </>
      )}
    </div>
  );
};

export default EventDetailPage;
